// v6,2
// , ??add auth token

// v6.2 make this nicer
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MapMarkerUpdateForm from './MapMarkerUpdateForm'; // Import the update form
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
// const { ObjectId } = require('mongodb');

// const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://192.168.0.102:3005/api/markers/';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://comtruaduytan.com/api/markers/';//'https://comtruaduytan.com/backend/api/markers/'

const isValidObjectId = (id) => {
    const objectIdRegex = /^[0-9a-fA-F]{24}$/;
    return objectIdRegex.test(id);
};

const MarkerForm = ({ lat, lon }) => {
    const [markers, setMarkers] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        location: {
            type: 'Point',
            coordinates: [0, 0 ],
        },
        userId: '671e566bf1105a8a7070e048',
        mapId: '671e566bf1105a8a7070e048',
        contributor: '671e566bf1105a8a7070e048',
        media: [],
        sharedWith: ["671e566bf1105a8a7070e048"],
        status: 'public',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [files, setFiles] = useState([]); // State to handle file uploads
    const [isEditing, setIsEditing] = useState(false); // Track if we're editing
    const [markerIdToEdit, setMarkerIdToEdit] = useState(null); // Store the ID of the marker being edited
    const [isSubmitting, setIsSubmitting] = useState(false); // Track if the form is submitting

    // Use useEffect to update coordinates when lat or lon changes
    useEffect(() => {
        setFormData(prevState => ({
            ...prevState,
            location: {
                type: 'Point',
                coordinates: [parseFloat(lat), parseFloat(lon)],
            },
        }));
    }, [lat, lon]); // Only re-run this effect if lat or lon changes

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]); // Add new files to the existing list
    };

    const handleRemoveFile = (fileToRemove) => {
        setFiles((prevFiles) => prevFiles.filter(file => file !== fileToRemove)); // Remove the selected file
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Disable button on submit
        setError(null); // Reset error before submission

        try {
            // Type checking
            if (!isValidObjectId(formData.userId)) throw new Error("Invalid User ID format.");
            if (!isValidObjectId(formData.mapId)) throw new Error("Invalid Map ID format.");
            if (!isValidObjectId(formData.contributor)) throw new Error("Invalid Contributor ID format.");
            if (typeof formData.title !== 'string' || formData.title.trim() === '') throw new Error("Title must be a non-empty string.");
            // if (typeof formData.description !== 'string' || formData.description.trim() === '') throw new Error("Description must be a string.");
            if (typeof formData.description !== 'string' || (formData.description.trim() === '' && formData.description !== '')) {
                throw new Error("Description must be a string.");
            }

            if (!Array.isArray(formData.sharedWith) || formData.sharedWith.length === 0) throw new Error("SharedWith must be a non-empty array.");
            // if (!files.length) throw new Error("At least one media file must be provided.");

            // Upload media files
            let mediaUrls = []; // Default to an empty array

            if (files && files.length > 0) {
                mediaUrls = await uploadMediaFiles();
                console.log('######## MarkerForm.js 2 ##########')
                console.log(mediaUrls)
            }

            // Retrieve token from localStorage
            const token = localStorage.getItem('token');

            // Construct the payload
            const payload = {
                ...formData,
                userId: formData.userId.trim(),
                mapId: formData.mapId.trim(),
                contributor: formData.contributor.trim(),
                location: formData.location,
                media: mediaUrls,
                sharedWith: formData.sharedWith.map(user => user.userId),
            };

            console.log('Submitting payload:', payload); // Log the payload

            // Send the request
            await axios.post(apiBaseUrl, payload, {
                headers: {
                  Authorization: `Bearer ${token}`, // Include token in the Authorization header
                },
              }
            );
            fetchMarkers();

            // Reload the page after successful submission
            // ** uncommment this after troubleshooting
            window.location.reload();


            // Reset form data
            setFormData({
                title: '',
                description: '',
                location: { type: 'Point', coordinates: [0, 0] },
                userId: '',
                mapId: '',
                contributor: '',
                media: [],
                sharedWith: [],
                status: 'public',
            });
            setFiles([]); // Clear the files after submission
        } catch (error) {
        //     setError(` ${error.response.data.message}`);
        //     console.error('Error submitting marker:', error.response?.data || error.message);
        // }
            if (error.response && error.response.data && error.response.data.message) {
                setError(` ${error.response.data.message}`);
            } else {
                setError('An unexpected error occurred.');
            }
            console.error('Error submitting marker:', error.response?.data || error.message);
        } finally {
            setIsSubmitting(false); // Re-enable button after submission attempt
        }
    };

    const uploadMediaFiles = async () => {

            const formData = new FormData();
            // console.log('############ in uploadMediaFiles ###########')

            files.forEach(file => {
                formData.append('files', file); // Append each file to FormData
            });

            try {
                const response = await axios.post(`${apiBaseUrl}/upload`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                // return response.data.mediaUrls; // Assuming the API returns an array of media URLs
                // console.log('############ Markerform.js 3 ###########')
                // console.log(response)
                return response.data.results; // Assuming the API returns an array of media URLs

            } catch (error) {
                console.error(error);
                throw new Error('Error uploading files');
            }

    };

    const oldFetchMarkers = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(apiBaseUrl);
            setMarkers(response.data);
        } catch (error) {
            setError('Error fetching markers');
            console.error('Error fetching markers:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMarkers = async () => {
        setLoading(true);
        setError(null);
        try {
            // Get the token from localStorage (or any other place it's stored)
            const token = localStorage.getItem('token');

            // Make the GET request with the Authorization header containing the JWT token
            const response = await axios.get(apiBaseUrl + 'own', {
                headers: {
                    Authorization: `Bearer ${token}`  // Include the token in the request header
                }
            });

            setMarkers(response.data);
        } catch (error) {
            // setError('Error fetching markers');
            setError(error.response.data.message);
            console.error('Error fetching markers:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMarkers();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'lat' || name === 'lon') {
            // const lat = parseFloat(formData.location.coordinates[1]);
            // const lon = parseFloat(formData.location.coordinates[0]);
            setFormData((prev) => ({
                ...prev,
                location: {
                    type: 'Point',
                    coordinates: name === 'lat' ? [lon, parseFloat(value)] : [parseFloat(value), lat],
                },
            }));
        } else if (name === 'sharedWith') {
            const sharedUsers = value.split(',')
                .map(id => id.trim())
                .filter(id => isValidObjectId(id));
            setFormData((prev) => ({
                ...prev,
                sharedWith: sharedUsers.map(id => ({ userId: id })),
            }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateMarker = async (updatedMarker) => {
        try {
          // Retrieve token from localStorage
          const token = localStorage.getItem('token');

          // Send the request
          await axios.put(`${apiBaseUrl}/${markerIdToEdit}`, updatedMarker, {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in the Authorization header
            },
          });
          fetchMarkers();
          setIsEditing(false);
          setMarkerIdToEdit(null);
        } catch (error) {
          setError(`Error updating marker: ${error.message}`);
          console.error('Error updating marker:', error.response?.data || error.message);
        }
      };

    return (
        <div style={{ fontFamily: "'Nunito', sans-serif", padding: '20px', backgroundColor: '#fff' }}>
            <h2 style={{
                marginBottom: '2px',
                fontSize: '1.4rem',
                // fontWeight: 'bold',
                color: '#000',
                paddingLeft: '5px',
                // fontWeight: '800',
                WebkitTextStroke: '1px black',
                fontFamily: "'Nunito', sans-serif"
            }}>
                Thêm đánh dấu
            </h2>

            {!isEditing ? (
                <form onSubmit={handleSubmit} style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)', maxWidth: '500px', margin: 'auto', fontFamily: "'Nunito', sans-serif" }}>
                    <input
                        type="text"
                        name="title"
                        placeholder="Tên địa điểm"
                        value={formData.title}
                        onChange={handleChange}
                        required
                        style={{...inputStyle, fontFamily: "'Nunito', sans-serif"}}
                    />
                    <textarea
                        name="description"
                        placeholder="Mô tả"
                        value={formData.description}
                        onChange={handleChange}
                        style={{ ...inputStyle, height: '100px', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <input
                        type="text"
                        name="lon"
                        placeholder="Longitude"
                        onChange={handleChange}
                        required
                        value={lon}
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <input
                        type="text"
                        name="lat"
                        placeholder="Latitude"
                        onChange={handleChange}
                        required
                        value={lat}
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <input
                        type="text"
                        name="userId"
                        placeholder="User ID (valid ObjectId)"
                        value={formData.userId}
                        onChange={handleChange}
                        required
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <input
                        type="text"
                        name="mapId"
                        placeholder="Map ID (valid ObjectId)"
                        value={formData.mapId}
                        onChange={handleChange}
                        required
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <input
                        type="text"
                        name="contributor"
                        placeholder="Contributor ID (valid ObjectId)"
                        value={formData.contributor}
                        onChange={handleChange}
                        required
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />

                    <input
                        type="file"
                        onChange={handleFileChange}
                        multiple
                        accept="image/*,video/*"
                        style={{...fileInputStyle, fontFamily: "'Nunito', sans-serif"}}
                    />
                    <div>
                        <h4 style={{...sectionTitleStyle, fontFamily: "'Nunito', sans-serif"}}>Media:</h4>
                        <ul style={mediaListStyle}>
                            {files.map((file, index) => (
                                <li key={index} style={mediaItemStyle}>
                                    {file.name}
                                    <button type="button" onClick={() => handleRemoveFile(file)} style={removeButtonStyle}>Remove</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <input
                        type="text"
                        name="sharedWith"
                        placeholder="Shared User IDs (comma separated)"
                        onChange={handleChange}
                        style={{ display: 'none', fontFamily: "'Nunito', sans-serif" }}
                    />
                    <select name="status" value={formData.status} onChange={handleChange} style={{...selectStyle, fontFamily: "'Nunito', sans-serif"}}>
                        <option value="public">Public</option>
                        <option value="private">Private</option>
                    </select>
                    <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
                        {isSubmitting ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                {' '}Đang upload...
                            </>
                        ) : (
                            'Thêm'
                        )}
                    </button>
                </form>
            ) : (
                <MapMarkerUpdateForm
                    marker={markers.find(marker => marker._id === markerIdToEdit)}
                    onSubmit={(updatedMarker) => {
                      if (updatedMarker) {
                        handleUpdateMarker(updatedMarker);
                      } else {
                        setIsEditing(false);
                        setMarkerIdToEdit(null);
                      }
                    }}
                />
            )}

            {error && <p style={{ color: 'red', textAlign: 'center', marginTop: '10px', fontFamily: "'Nunito', sans-serif" }}>{error}</p>}

            <h2 style={{ color: '#333', fontSize: '24px', marginTop: '40px', fontFamily: "'Nunito', sans-serif",                 WebkitTextStroke: '1px black',
            }}>Danh sách điểm đánh dấu</h2>

            {loading ? (
                <p style={{ fontFamily: "'Nunito', sans-serif" }}>Loading markers...</p>
            ) : (
                <div
                    style={{
                        maxHeight: '400px',
                        overflowX: 'auto',
                        // border: '1px solid #ccc',
                        padding: '20px',
                        marginTop: '10px',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)',
                        fontFamily: "'Nunito', sans-serif"
                    }}
                >
                    <ul
                        style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            listStyle: 'none',
                            padding: '0',
                            margin: '0',
                            fontFamily: "'Nunito', sans-serif"
                        }}
                    >
                        {markers.map(marker => (
                            <li
                                key={marker._id}
                                style={{
                                    minWidth: '250px',
                                    marginRight: '10px',
                                    border: '1px solid #ddd',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    // boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                    fontFamily: "'Nunito', sans-serif",
                                    color: '#777',

                                }}
                            >
                                <h3 style={{ color: '#333', fontSize: '20px', marginBottom: '10px', fontFamily: "'Nunito', sans-serif" }}>{marker.title}</h3>

                                <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '15px' }}><strong>Description:</strong> {marker.description}</p>

                                <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '15px' }}><strong>Latitude:</strong> {marker.location.coordinates[1]}</p>

                                <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '15px' }}><strong>Longitude:</strong> {marker.location.coordinates[0]}</p>

                                <button
                                    style={editButtonStyle}
                                    onClick={() => {
                                        setIsEditing(true);
                                        setMarkerIdToEdit(marker._id);
                                      }}
                                >
                                    Edit
                                </button>

                                <div>
                                    <strong>Media:</strong>
                                    <ul style={{ padding: '0', listStyle: 'none' }}>
                                        {marker.media.map((media) => (
                                            <li key={media._id} style={mediaItemStyle}>
                                                {media.type === 'image' ? (
                                                    <img
                                                        src={`https://${media.url}`}
                                                        alt={marker.title}
                                                        style={{ maxWidth: '100%', height: 'auto', fontFamily: "'Nunito', sans-serif" }}
                                                    />
                                                ) : media.type === 'video' ? (
                                                    <video controls style={{ maxWidth: '100%', height: 'auto', fontFamily: "'Nunito', sans-serif" }}>
                                                        <source src={`https://${media.url}`} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                ) : (
                                                    <a href={media.url} target="_blank" rel="noopener noreferrer" style={mediaLinkStyle}>
                                                        Media Link
                                                    </a>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};


const inputStyle = {
    width: '100%',
    padding: '3px',
    margin: '5px 0',
    borderRadius: '4px',
    border: '1px solid #ddd',
    fontSize: '16px',
    backgroundColor: '#f9f9f9',
    fontFamily: "'Nunito', sans-serif"
};

const fileInputStyle = {
    padding: '3px',
    margin: '5px 0',
    width: '100%',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontFamily: "'Nunito', sans-serif"
};

const sectionTitleStyle = {
    fontSize: '18px',
    marginBottom: '10px',
    fontFamily: "'Nunito', sans-serif"
};

const mediaListStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    fontFamily: "'Nunito', sans-serif"
};

const mediaItemStyle = {
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "'Nunito', sans-serif"
};

const removeButtonStyle = {
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '5px 10px',
    cursor: 'pointer',
    fontFamily: "'Nunito', sans-serif"
};

const submitButtonStyle = {
    // padding: '10px 20px',
    // backgroundColor: '#3498db',
    // color: 'white',
    // border: 'none',
    // borderRadius: '5px',
    // cursor: 'pointer',
    width: '100%',
    // marginTop: '20px',
    // fontSize: '16px',
    backgroundColor: '#007bff',  // Button color
    color: 'white',  // Text color
    padding: '12px 20px',  // Padding
    fontSize: '16px',  // Font size
    fontWeight: '600',  // Bold text
    borderRadius: '8px',  // Rounded corners
    border: 'none',  // No border
    cursor: 'pointer',  // Pointer cursor on hover
    transition: 'background-color 0.3s ease, transform 0.2s ease',  // Smooth transitions
    boxShadow: '0 4px 10px rgba(0, 123, 255, 0.3)',  // Subtle shadow
    fontFamily: "'Nunito', sans-serif"
};

const selectStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    borderRadius: '4px',
    border: '1px solid #ddd',
    backgroundColor: '#f9f9f9',
    fontSize: '16px',
    fontFamily: "'Nunito', sans-serif"
};

const editButtonStyle = {
    marginTop: '10px',
    padding: '8px 16px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontFamily: "'Nunito', sans-serif"
};

const mediaLinkStyle = {
    color: '#3498db',
    textDecoration: 'none',
    fontFamily: "'Nunito', sans-serif"
};

export default MarkerForm;
